import React, { useState, useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Stack,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Assets
import { ReactComponent as CloseIcon } from "assets/images/icons/icn_close.svg";
import { ReactComponent as AddIcon } from "assets/images/icons/btn_add.svg";

// Components
import { OutlineRectangleButton } from "components/buttons/OutlineRectangleButton";
import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidButton } from "components/buttons/SolidButton";

// Util
import { parseLicenseKeyCsv } from "./util/func";

const ImportView = ({
  getViewTitle,
  form,
  handleImportOverlay,
}) => {
  const theme = useTheme();

  // Status
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);

  // Method
  const openFileBrowser = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    if (!selectedFile.name.toLowerCase().endsWith(".csv")) {
      e.target.value = "";
      return;
    }

    setFile(selectedFile);
    e.target.value = "";
  };

  const handleUpload = () => {
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      const content = reader.result;
      const keys = parseLicenseKeyCsv(content);
      handleImportOverlay.updateKeys(keys);
    };
    reader.readAsText(file);
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.customFontSize[5],
            fontWeight: theme.typography.customFontWeight[3],
            paddingLeft: "20px",
          }}
        >
          {getViewTitle()}
        </Typography>
        <Button
          onClick={handleImportOverlay.closeView}
          sx={{
            backgroundColor: theme.palette.primary.transparent,
            boxShadow: "none",
            "&:hover": {
              backgroundColor: theme.palette.primary.transparent,
            },
          }}
        >
          <CloseIcon />
        </Button>
      </Box>

      <Box
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: '20px',
        }}
      >
        <Box
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr auto',
            alignItems: 'center',
            width: '80%',
            gap: '20px',
            marginTop: '40px',
          }}
        >
          <Box sx={form.getLabelStyle()}>Choice File:</Box>
          <Box style={{ maxWidth: '100%' }}>
            <TextField
              variant="outlined"
              size="small"
              value={file ? file.name : ""}
              placeholder="Select a file"
              disabled
              sx={{ ...form.getTextfieldStyle(true), width: '100%' }}
            />
            <input
              type="file"
              ref={fileInputRef}
              accept=".csv,text/csv"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </Box>
          <OutlineRectangleButton
            startIcon={<AddIcon />}
            height="32px"
            onClick={openFileBrowser}
          >
            Browse
          </OutlineRectangleButton>
        </Box>
      </Box>

      <Box
        sx={{
          margin: "24px 0 16px auto",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <OutlineButton
          onClick={handleImportOverlay.closeView}
          sx={{ marginRight: "20px" }}
          width="100px"
          height="32px"
        >
          Cancel
        </OutlineButton>
        <SolidButton
          onClick={handleUpload}
          width="100px"
          height="32px"
          disabled={!file}
        >
          Upload
        </SolidButton>
      </Box>
    </>
  )
}

export default ImportView;
